// The editor's reads, started before the editor opens (hover or focus on "Open editor" / Content › Editor). Kept apart
// from EditorRoute so the shell can import it without pulling the editor, its preview frame and the replay player
// into the shell's bundle.
import type { QueryClient } from "@tanstack/react-query";
import { rememberJourney, type WebsiteRecord } from "@/lib/websites";
import { prefetchWorkspace } from "./model";

export function prefetchEditor(qc: QueryClient, w: Pick<WebsiteRecord, "ref" | "journey_id">, page?: string | null) {
  if (!w.journey_id) return;
  rememberJourney(w);
  prefetchWorkspace(qc, w.journey_id, page || "/");
  // And the editor's code, so a cold open does not wait for its chunk after the click (a dynamic import: the shell's
  // own bundle still never contains the editor).
  if (!codeAsked) { codeAsked = true; void import("./EditorRoute").catch(() => { codeAsked = false; }); }
}
let codeAsked = false;
